export enum ScriptingLanguage {
    Bash = "Bash",
    CSharp = "CSharp",
    PowerShell = "PowerShell",
    Python = "Python",
}
